module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Opa! A conta {account} ainda não tem acesso ao Shop.","text":"Descubra novas formas de vender e conquiste clientes com mais facilidade.","dashCTA":"Ir para o dash"},"en-US":{"title":"Ops! The account {account} doesn\u0027t have access to Shop yet.","text":"Learn new ways to sell and attract clients more easily.","dashCTA":"Go to dash"}}')
  delete Component.options._Ctor
}
